import { render, staticRenderFns } from "./Case713dz.vue?vue&type=template&id=6bb0e7e6&scoped=true&"
import script from "./Case713dz.vue?vue&type=script&lang=js&"
export * from "./Case713dz.vue?vue&type=script&lang=js&"
import style0 from "./Case713dz.vue?vue&type=style&index=0&id=6bb0e7e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb0e7e6",
  null
  
)

export default component.exports